import { cookies } from 'sharedKernel/cookies/behavior'
import { MEETING_ROOM_ALLOWED_EMAIL } from 'sharedKernel/constants'
import { loggedUser } from 'sharedKernel/user/LoggedUser'

export const hasAccess = (permissionToFind: string, accessToFind: string): boolean => {
  const features = cookies.get('_perm')?.features

  if (features !== undefined) {
    const permission = features.find((feature) => feature.code === permissionToFind)

    if (permission !== undefined) {
      const accesses = permission.accesses
      
      if (accesses && Array.isArray(accesses)) {
        const access = accesses.find((access) => access.code === accessToFind)
        
        if (access !== undefined) {
          return true
        }
      }
    }
  }
  return false
}

export const canAccessMeetingRoom = (): boolean => {
  const currentUserEmail = loggedUser.get().email?.trim().toLowerCase() ?? ''

  return currentUserEmail === MEETING_ROOM_ALLOWED_EMAIL.trim().toLowerCase()
}
